
import CommonUtils from "@/common-utils";
import Constants from "@/constants";
import axios from "axios";
import debounce from "lodash-es/debounce";
import { Swiper } from "swiper/js/swiper.esm";
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { ProductVO } from "../product/vo/product.vo";
import { DisplayOVO, LayoutDisplayItemOVO } from "./vo/main.vo";

@Component
export default class VirtialCategory extends Vue {
  @Prop()
  active!: boolean;
  @Prop()
  display!: DisplayOVO;
  @PropSync("currentSubMenuIdx", { default: 0 })
  selectedVirtualCategoryIndex!: number;

  busy = false; // loadmore 중임?

  // 가상카테고리탭
  swiperVirtualCategoryTab: Swiper;
  // 프로모션 탭 스와이퍼
  swiperVirtualCategoryTab2: Swiper;
  swiperVirtualCategoryTabOption = {
    slidesPerView: "auto",
    spaceBetween: this.$isMobile ? 10 : 5,
    nested: false,
  };

  // 가상카테고리
  swiperVirtualCategory: Swiper;
  swiperVirtualCategoryOption = {
    slidesPerView: 1,
    autoHeight: true,
    on: {
      slideChange: this.onVirtualCategorySwiped,
    },
    nested: true,
    lazy: true,
  };

  // computed

  // methods
  // 이미지 로드되면 layout 영역 height가 바뀜. 부모쪽 스와이퍼 update autoheight 발생 시켜야함
  onImageLoaded = debounce(this.onLayoutUpdated, 200);
  onLayoutUpdated() {
    this.$nextTick()
      .then(() => {
        this.swiperVirtualCategory && this.swiperVirtualCategory.updateAutoHeight();
      })
      .then(() => {
        this.$emit("layout-update");
      });
  }

  // 찜
  btnZzim(product: ProductVO) {
    CommonUtils.zzimProduct(product).then();
  }

  // 행 상품 노출 개수 가져오기(모바일/PC 환경)
  getRowPerView(dispay: DisplayOVO) {

    if(this.$isMobile) {
      return dispay.slidesPerViewMobile 
                ? dispay.slidesPerViewMobile
                : 3;
    }

    return dispay.slidesPerViewPc 
              ? dispay.slidesPerViewPc
              : 4;
  }
  
  // 가상카테고리
  @Watch("selectedVirtualCategoryIndex")
  onVirtualCategoryIndexChanged() {
    if (!this.swiperVirtualCategory) {
      return;
    }
    this.swiperVirtualCategory.slideTo(this.selectedVirtualCategoryIndex);
    this.swiperVirtualCategoryTab && this.swiperVirtualCategoryTab.slideTo(this.selectedVirtualCategoryIndex);
    this.swiperVirtualCategoryTab2 && this.swiperVirtualCategoryTab2.slideTo(this.selectedVirtualCategoryIndex);
    window.scrollTo(0, -Constants.MENU_POSITION_TOP);
  }
  onVirtualCategorySwiped() {
    // 위 Watch 때문에 swiperVirtualCategory.slideTo가 호출 되는데, 같은 index라 별 지장 없는듯.
    // 누더기 없이 구현 방법 있으면 수정 ㄱㄱ FIXME
    this.selectedVirtualCategoryIndex = this.swiperVirtualCategory.activeIndex;
    this.swiperVirtualCategoryTab.slideTo(this.swiperVirtualCategory.activeIndex);
  }

  onLoadMore() {
    if (!this.active || this.display.displayCd != 6) {
      return;
    }
    this.busy = true;
    const displayItem = this.display.displayItems[this.selectedVirtualCategoryIndex];

    // 다 불러오면 ㅂ
    if (!displayItem || displayItem.products.length >= displayItem.displayLimit) {
      this.busy = false;
      return;
    }
    const params = {
      pageStart: displayItem.products.length,
      displayLimit: displayItem.displayLimit,
      discountType: displayItem.discountType,
      orderByCd: displayItem.orderByCd
    };
    axios.get(`/main/virtual-category/${displayItem.virtualCategoryCd}`, { params: params }).then((r) => {
      displayItem.displayLimit = r.data.length==0? r.data.length : displayItem.displayLimit;  //불러온 데이터가 없으면 limit 0
      displayItem.products = displayItem.products.concat(r.data);
      this.busy = false;
    });
  }

  // 스크롤 헬퍼 (오프셋 포함)
  scrollToElement(el: HTMLElement, offset = -80) {
    const targetTop = el.getBoundingClientRect().top + window.pageYOffset + offset;
    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  }

  // 프로모션 탭 클릭 시 처리
  onPromotionTabClick(index: number) {
    this.selectedVirtualCategoryIndex = index;
    this.$nextTick(() => {
      const rawRef: any = this.$refs[`vtCategory${this.display.displayItems[index].seq}`];
      const maybeEl: any = Array.isArray(rawRef) ? rawRef[0] : rawRef;
      const node: any = maybeEl && maybeEl.$el ? maybeEl.$el : maybeEl;
      if (node && node.getBoundingClientRect) {
        this.scrollToElement(node as HTMLElement, -80);
      }
    });
  }
}
